import { IncomeKbn } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職した月以前6ヶ月の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];

const explanatoryText = (
  <div className="explanatoryText">
    <a
      href={`${
        process.env.PUBLIC_URL ?? ""
      }/assets/pdf/≪別紙≫都道府県の共済制度一覧.pdf`}
      target="_blank"
      rel="noopener noreferrer"
    >
      都道府県の退職手当金の制度
    </a>
    から発行された<span className="bold">退職所得の源泉徴収票</span>（
    <span className="red">給与所得の源泉徴収票ではありません</span>
    ）を共済契約者が保管している場合は、当該源泉徴収票のアップロードと内容の登録行い、「次へ」ボタンを押してください。
    <br />
    なお、都道府県の退職手当金の制度以外からも退職手当金の支給がある場合は、該当退職手当金にかかる源泉徴収票についても登録が必要となりますので、「続けて登録」ボタンを押して内容を入力し、完了後、「次へ」ボタンを押してください。
    <br />
    源泉徴収票が発行されていない場合は、後で登録いただくことも可能ですので、「後で登録」ボタンを選択（源泉徴収票の枚数を選択すると表示されます。）して、「次へ」ボタンを押してください。
    <br />
    ※退職手当金請求時には源泉徴収票が必要であるため、ここで登録いただいた内容を退職手当金の請求時の添付書類として扱います。
    <br />※
    <a
      href={`${
        process.env.PUBLIC_URL ?? ""
      }/assets/pdf/≪別紙≫退職所得の源泉徴収票.pdf`}
      target="_blank"
      rel="noopener noreferrer"
    >
      退職所得の源泉徴収票
    </a>
    は、所得税法第２０３条１項及び所得税法基本解釈通達201－1に基づく福祉医療機構への通報書として登録をいただくものです。
    <br />※
    <a
      href={`${
        process.env.PUBLIC_URL ?? ""
      }/assets/pdf/≪別紙≫給与所得の源泉徴収票.pdf`}
      target="_blank"
      rel="noopener noreferrer"
    >
      給与所得の源泉徴収票
    </a>
    は不要です。添付しないでください。
  </div>
);

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
    helpicon: true,
    helpText: "被共済職員の番号です。",
  },
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
    helpicon: true,
    helpText: (
      <>
        退職する被共済職員の氏名です。
        <br />
        外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されない場合があります。
      </>
    ),
  },
  {
    keyword: "break",
    type: "lineTitle",
  },
  {
    keyword: "explanatoryText",
    type: "explanatoryText",
    explanatoryText: "退職所得に係る情報を入力してください。",
  },
  {
    title: "源泉徴収票の登録枚数",
    keyword: "regNum",
    type: "selectForm",
    selectPropsList: [
      {
        value: 0,
        label: "不要",
      },
      {
        value: 1,
        label: "1枚",
      },
      {
        value: 2,
        label: "2枚",
      },
      {
        value: 3,
        label: "3枚",
      },
    ],
  },
  {
    title: "後で登録",
    keyword: "regLater",
    type: "checkboxGroup",
    checkBoxList: [{ label: "" }],
  },
  {
    title: "就労年月日",
    keyword: "dateEmp",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている就労年月日を入力してください。",
  },
  {
    title: "退職年月日",
    keyword: "dateRetiree",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている退職年月日を入力してください。",
  },
  {
    title: "区分",
    keyword: "classIfication",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている区分から該当のものを選んでください。",
  },
  {
    title: "支払金額",
    keyword: "paymentAmt",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている支払金額を入力してください。",
  },
  {
    title: "源泉徴収額",
    keyword: "levyAmount",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額を入力してください。",
  },
  {
    title: "特別徴収税額：市町村民税",
    keyword: "specialAmount",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText:
      "源泉徴収票に記載された源泉徴収税額のうちの市町村民税額を入力してください。",
  },
  {
    title: "特別徴収税額：都道府県税",
    keyword: "prefecturesAmount",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    helpicon: true,
    helpText:
      "源泉徴収票に記載された源泉徴収税額のうちの都道府県民税額を入力してください。",
  },
  {
    title: "勤続年数",
    keyword: "conYears",
    type: "amount",
    innerText: "年",
    inputProps: { maxLength: 2 },
    requiredIcon: true,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載された勤続年数を入力してください。",
  },
  {
    title: "退職所得の源泉徴収票",
    keyword: "sourceBill",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "他の制度等から支給された退職金にかかる退職所得の源泉徴収票です。",
    id: "1",
  },
  {
    title: "控除期間（年）",
    keyword: "deductionYear",
    type: "label",
    requiredIcon: true,
  },
  {
    title: "控除期間（月）",
    keyword: "deductionMonth",
    type: "label",
    requiredIcon: true,
  },
  //　二枚目
  {
    title: "",
    keyword: "title",
    type: "lineTitle",
  },
  {
    title: "後で登録",
    keyword: "regLaterTwo",
    type: "checkboxGroup",
    checkBoxList: [{ label: "" }],
  },
  {
    title: "就労年月日",
    keyword: "dateEmpTwo",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている就労年月日を入力してください。",
    showLine: false,
  },
  {
    title: "退職年月日",
    keyword: "dateRetireeTwo",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている退職年月日を入力してください。",
  },
  {
    title: "区分",
    keyword: "classIficationTwo",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている区分から該当のものを選んでください。",
  },
  {
    title: "支払金額",
    keyword: "paymentAmtTwo",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    showLine: false,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている支払金額を入力してください。",
  },
  {
    title: "源泉徴収額",
    keyword: "levyAmountTwo",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額を入力してください。",
  },
  {
    title: "特別徴収税額：市町村民税",
    keyword: "specialAmountTwo",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    showLine: false,
    helpicon: true,
    helpText:
      "源泉徴収票に記載された源泉徴収税額のうちの市町村民税額を入力してください。",
  },
  {
    title: "特別徴収税額：都道府県税",
    keyword: "prefecturesAmountTwo",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    showLine: false,
    helpicon: true,
    helpText:
      "源泉徴収票に記載された源泉徴収税額のうちの都道府県民税額を入力してください。",
  },
  {
    title: "勤続年数",
    keyword: "conYearTwo",
    type: "amount",
    innerText: "年",
    inputProps: { maxLength: 2 },
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載された勤続年数を入力してください。",
  },
  {
    title: "退職所得の源泉徴収票",
    keyword: "sourceBillTwo",
    type: "fileUpload",
    requiredIcon: true,
    id: "2",
    showLine: false,
    helpicon: true,
    helpText:
      "他の制度等から支給された退職金にかかる退職所得の源泉徴収票です。",
  },
  {
    title: "控除期間（年）",
    keyword: "deductionYearTwo",
    type: "label",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "控除期間（月）",
    keyword: "deductionMonthTwo",
    type: "label",
    requiredIcon: true,
    showLine: false,
  },
  // 三枚目
  {
    title: "",
    keyword: "title",
    type: "lineTitle",
  },
  {
    title: "後で登録",
    keyword: "regLaterThree",
    type: "checkboxGroup",
    checkBoxList: [{ label: "" }],
  },
  {
    title: "就労年月日",
    keyword: "dateEmpThree",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている就労年月日を入力してください。",
  },
  {
    title: "退職年月日",
    keyword: "dateRetireeThree",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている退職年月日を入力してください。",
  },
  {
    title: "区分",
    keyword: "classIficationThree",
    type: "selectForm",
    selectPropsList: TkGetCodeList(IncomeKbn),
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている区分から該当のものを選んでください。",
  },
  {
    title: "支払金額",
    keyword: "paymentAmtThree",
    type: "amount",
    requiredIcon: true,
    inputProps: { maxLength: 9 },
    showLine: false,
    helpicon: true,
    helpText:
      "退職所得の源泉徴収票に記載されている支払金額を入力してください。",
  },
  {
    title: "源泉徴収額",
    keyword: "levyAmountThree",
    type: "amount",
    inputProps: { maxLength: 9 },
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText: "源泉徴収票に記載された源泉徴収税額を入力してください。",
  },
  {
    title: "特別徴収税額：市町村民税",
    keyword: "specialAmountThree",
    type: "amount",
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText:
      "源泉徴収票に記載された源泉徴収税額のうちの市町村民税額を入力してください。",
  },
  {
    title: "特別徴収税額：都道府県税",
    keyword: "prefecturesAmountThree",
    type: "amount",
    inputProps: { maxLength: 9 },
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText:
      "源泉徴収票に記載された源泉徴収税額のうちの都道府県民税額を入力してください。",
  },
  {
    title: "勤続年数",
    keyword: "conYearThree",
    type: "amount",
    innerText: "年",
    inputProps: { maxLength: 2 },
    requiredIcon: true,
    showLine: false,
    helpicon: true,
    helpText: "退職所得の源泉徴収票に記載された勤続年数を入力してください。",
  },
  {
    title: "退職所得の源泉徴収票",
    keyword: "sourceBillThree",
    type: "fileUpload",
    requiredIcon: true,
    id: "3",
    showLine: false,
    helpicon: true,
    helpText:
      "他の制度等から支給された退職金にかかる退職所得の源泉徴収票です。",
  },
  {
    title: "控除期間（年）",
    keyword: "deductionYearThree",
    type: "label",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "控除期間（月）",
    keyword: "deductionMonthThree",
    type: "label",
    requiredIcon: true,
    showLine: false,
  },
];
const schemaRegNum = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};
const schema = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  sourceBill: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmp: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetiree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIfication: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYears: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYear: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};
const schemaTwo = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  sourceBill: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmp: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetiree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIfication: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYears: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYear: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  // 二枚目
  sourceBillTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};
const schemaThree = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  sourceBill: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmp: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetiree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIfication: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYears: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYear: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  // 二枚目
  sourceBillTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  // 三枚目
  sourceBillThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};
const schemaOnlyTwo = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  // 二枚目
  sourceBillTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};
const schemaOnlyThree = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  // 三枚目
  sourceBillThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};
const schemaTwoAndThree = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  // 二枚目
  sourceBillTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthTwo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  // 三枚目
  sourceBillThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};
const schemaOneAndThree = {
  regNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  sourceBill: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmp: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetiree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIfication: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmount: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYears: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYear: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  // 三枚目
  sourceBillThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateEmpThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  dateRetireeThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  classIficationThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  paymentAmtThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  levyAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  specialAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  prefecturesAmountThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  conYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 2,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "99"),
    },
  },
  deductionYearThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 99,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "99"),
    },
  },
  deductionMonthThree: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
};

export {
  explanatoryText,
  fakeTableList,
  schemaRegNum,
  schema,
  schemaOneAndThree,
  schemaOnlyThree,
  schemaOnlyTwo,
  schemaThree,
  schemaTwo,
  schemaTwoAndThree,
  stepper,
};
